<script lang="ts" setup>
import { ref, defineEmits } from "vue";
const active = ref(true);
const emit = defineEmits(["close"]);

const close = () => {
  active.value = false;
  emit("close", false);
};
</script>
<template>
  <div
    class="fixed w-full h-full bg-black/70 inset-0 flex justify-center items-center z-50 popup"
    :class="{ active: active }"
    v-if="active"
  >
    <div
      class="bg-red-50 text-red-700 rounded p-[.5em] w-full shadow-xl max-w-sm"
    >
      <img src="/cancel.png" class="max-w-[5em] m-auto my-8" />
      <p class="w-full text-center mb-[2em] text-[.9em] leading-[1.2em]">
        <slot></slot>
      </p>
      <div class="flex justify-center mb-[1em]">
        <button class="button" @click="close">
          {{ $t("valid_popup.leave") }}
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.popup {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  animation: fadeOut 0.3s forwards;
}
.popup.active {
  display: flex;
  opacity: 1;
  animation: fadeIn 0.3s forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
